import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\ttext-decoration: none;\n\t", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n\t", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n\t\t\t\t\t& {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t@media (hover: hover) {\n\t\t\t\t\t\t:hover,\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t\t:focus {\n\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t:active {\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t}\n\t\t\t  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t\tbackground: ", ";\n\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\tcolor: ", ";\n\t\t\t  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t", ";\n\tdisplay: inline-flex;\n\ttext-align: center;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: 44px;\n\tmargin: 0;\n\tpadding: 0 ", ";\n\tborder: 2px solid;\n\tborder-radius: 22px;\n\toutline: none;\n\ttransition: all 0.2s ease-in-out;\n\t", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { createA11yOutlineStyles } from '../helpers';
import { css, styled } from '../theme-provider';
export var ButtonAppearance;

(function (ButtonAppearance) {
  ButtonAppearance["Primary"] = "Primary";
  ButtonAppearance["Secondary"] = "Secondary";
})(ButtonAppearance || (ButtonAppearance = {}));

export var ButtonType;

(function (ButtonType) {
  ButtonType["Submit"] = "submit";
  ButtonType["Reset"] = "reset";
  ButtonType["Button"] = "button";
})(ButtonType || (ButtonType = {}));

var buttonStyle = css(_templateObject(), function (props) {
  return props.stretchContent && 'width: 100%;';
}, function (props) {
  return props.theme.size.static450;
}, function (props) {
  var appearance = props.appearance;
  var textRecipe = props.theme.interaction[appearance === ButtonAppearance.Primary ? 'recipe750' : 'recipe450'];
  var transparentRecipe = {
    default: 'transparent',
    disabled: 'transparent',
    hover: 'transparent',
    active: 'transparent'
  };
  var backgroundRecipe = appearance === ButtonAppearance.Primary ? props.theme.interaction.recipe450 : transparentRecipe;
  var borderRecipe = props.theme.interaction.recipe450;
  return props.disabled ? css(_templateObject2(), backgroundRecipe.disabled, borderRecipe.disabled, textRecipe.disabled) : css(_templateObject3(), backgroundRecipe.default, borderRecipe.default, textRecipe.default, backgroundRecipe.hover, borderRecipe.hover, textRecipe.hover, createA11yOutlineStyles(props), backgroundRecipe.active, borderRecipe.active, textRecipe.active);
});
var StyledButton = styled.button.withConfig({
  displayName: "StyledButton",
  componentId: "sc-1gcpt77"
})(_templateObject4(), buttonStyle);
var StyledButtonLink = styled.a.withConfig({
  displayName: "StyledButtonLink",
  componentId: "sc-v4r7p2"
})(_templateObject5(), buttonStyle);
export var Button = function Button(props) {
  var _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? ButtonAppearance.Secondary : _props$appearance,
      children = props.children,
      disabled = props.disabled,
      innerRef = props.innerRef,
      onClick = props.onClick,
      stretchContent = props.stretchContent,
      type = props.type;
  return React.createElement(StyledButton, {
    disabled: disabled,
    appearance: appearance,
    type: type,
    onClick: onClick,
    stretchContent: stretchContent,
    ref: innerRef
  }, children);
};
export var ButtonLink = function ButtonLink(props) {
  var _props$appearance2 = props.appearance,
      appearance = _props$appearance2 === void 0 ? ButtonAppearance.Secondary : _props$appearance2,
      children = props.children,
      disabled = props.disabled,
      href = props.href,
      target = props.target,
      innerRef = props.innerRef,
      rel = props.rel,
      title = props.title,
      onClick = props.onClick,
      stretchContent = props.stretchContent;
  return React.createElement(StyledButtonLink, {
    disabled: disabled,
    appearance: appearance,
    href: href,
    target: target,
    ref: innerRef,
    rel: rel,
    title: title,
    onClick: onClick,
    stretchContent: stretchContent
  }, children);
};